@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';
@import '../../../constants/spacing.module.less';
@import (reference) '../settings-page.module.less';

.content {
  padding: @settings-page-content-padding;
  max-width: 800px;
}

.supplies-store {
  min-width: 265px;
  height: 72px;
  border-radius: 8px;
  border: 1px solid var(--grey-300);
  background-color: var(--grey-200);
  padding: @space-16;
  margin-top: @space-24;

  & a {
    font-size: 16px;
    line-height: 24px;

    > svg {
      margin-left: 8px;
      width: 13px;
    }
  }

  & p {
    font-size: 14px;
    line-height: 16px;
    margin: 0;
  }
}

.description {
  font-size: 16px;
  line-height: 24px;
  max-width: 649px;
}

.connect-offline-banner {
  margin-top: @space-12;
}

.grid {
  display: grid;
  grid-template-columns: auto auto auto auto;
  border: @settings-page--table--border;
  border-bottom: none; // last row got dis
  margin-top: 20px;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  .header-cell {
    display: flex;
    align-items: center;
    font-weight: @settings-page--table--header--cell--font-weight;
    min-width: 150px;
    padding: @settings-page--table--cell--padding;
    background-color: @settings-page--table--header--cell--background-color;
    color: @settings-page--table--header--cell--text-color;
  }

  .cell {
    padding: @settings-page--table--cell--padding;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: @settings-page--table--border;
    background-color: @settings-page--table--body--cell--background-color;
    color: @settings-page--table--body--cell--text-color;
  }
}

.icon-container {
  display: inline;
}

.info-icon {
  margin-bottom: @space-4;
  margin-left: @space-8;
  cursor: pointer;
  color: @primary-button--background-color;
  height: @space-16;
  width: auto;
  vertical-align: middle;
}

.warnings-settings {
  margin-top: @space-24;
  margin-bottom: @space-24;
}

.warnings-settings-description {
  margin-top: @space-8;
  margin-bottom: @space-16;
  max-width: 649px;
}
